import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { FaTimes, FaCheck } from 'react-icons/fa';

function GiftSetModal({ isOpen, onClose, onAddToCart, giftSet }) {
  const [availableFlavors, setAvailableFlavors] = useState([]);
  const [selectedFlavors, setSelectedFlavors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      loadFlavors();
    }
  }, [isOpen]);

  const loadFlavors = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'products'));
      const products = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(p => p.category !== 'giftSets' && p.stock > 0);
      setAvailableFlavors(products);
      setLoading(false);
    } catch (error) {
      console.error('Ошибка загрузки вкусов:', error);
      setLoading(false);
    }
  };

  const toggleFlavor = (flavor) => {
    if (selectedFlavors.find(f => f.id === flavor.id)) {
      setSelectedFlavors(selectedFlavors.filter(f => f.id !== flavor.id));
    } else {
      if (selectedFlavors.length < 2) {
        setSelectedFlavors([...selectedFlavors, flavor]);
      } else {
        alert('Можно выбрать максимум 2 вкуса');
      }
    }
  };

  const handleAddToCart = () => {
    if (selectedFlavors.length !== 2) {
      alert('Выберите 2 вкуса для подарочного набора');
      return;
    }

    const giftSetWithFlavors = {
      ...giftSet,
      selectedFlavors: selectedFlavors.map(f => f.name),
      name: `${giftSet.name} (${selectedFlavors.map(f => f.name).join(', ')})`
    };

    onAddToCart(giftSetWithFlavors);
    setSelectedFlavors([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content gift-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Выберите 2 вкуса для набора</h3>
          <button className="btn-icon" onClick={onClose}><FaTimes /></button>
        </div>

        <div className="gift-modal-body">
          <div className="selected-count">
            Выбрано: {selectedFlavors.length} из 2
          </div>

          {loading ? (
            <div className="loading-state">Загрузка вкусов...</div>
          ) : (
            <div className="flavors-grid">
              {availableFlavors.map(flavor => {
                const isSelected = selectedFlavors.find(f => f.id === flavor.id);
                return (
                  <div
                    key={flavor.id}
                    className={`flavor-card ${isSelected ? 'selected' : ''}`}
                    onClick={() => toggleFlavor(flavor)}
                  >
                    {flavor.images && flavor.images.length > 0 ? (
                      <img src={flavor.images[0]} alt={flavor.name} />
                    ) : (
                      <div className="flavor-placeholder">🌿</div>
                    )}
                    <div className="flavor-info">
                      <h4>{flavor.name}</h4>
                      <p>{flavor.composition}</p>
                    </div>
                    {isSelected && (
                      <div className="selected-badge">
                        <FaCheck /> Выбрано
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          <div className="gift-set-contents">
            <h4>В набор входит:</h4>
            <ul>
              <li>Бутылка - 2 шт.</li>
              <li>Рюмка - 2 шт.</li>
              <li>Набор трав и специй - 2 шт. (выбранные вкусы)</li>
              <li>Этикетка - 2 шт.</li>
              <li>Камень для охлаждения напитков - 2 шт.</li>
              <li>Подарочная коробка - 1 шт.</li>
              <li>Пакет с фирменным логотипом - 1 шт.</li>
              <li>Поздравление от команды «Дух Приморья» - 1 шт.</li>
            </ul>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Отмена
            </button>
            <button
              type="button"
              className="btn-primary"
              onClick={handleAddToCart}
              disabled={selectedFlavors.length !== 2}
            >
              Добавить в корзину
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GiftSetModal;
